var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"sticky-footer bg-acp"},[_c('div',{staticClass:"my-auto"},[_c('div',{staticClass:"copyright text-center my-auto"},[_c('img',{attrs:{"src":require("@/assets/Logo_Branco_1.png"),"width":"60"}})])])])
}]

export { render, staticRenderFns }